import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated"
import { defaultPosition, ILandingFloat, ILandingSection } from "../../../../data/interfaces"
import Primitive from "../Primitive"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { MENU_ITEM_DIVIDER, MENU_ITEM_ICON_DIVIDER } from "src/libs/basic-view/ExtendMenu"

/* Protopia Ecosystem component */
export interface IFloatProps { 
    float: ILandingFloat
    i:number
    section: ILandingSection
    animated?: ANIMATED_STYLE[]
    animated_delay?: ANIMATE_DELAY
}
const FloatContent = ({float, ...props}: IFloatProps): JSX.Element => { 
    const isEdit = useLandingStore((state: ILandingStore) => state.isEdit) 
    
    const transform = JSON.stringify(float.position) !== JSON.stringify( defaultPosition() ) 
        ?
        `Reset transform${MENU_ITEM_ICON_DIVIDER}cross${MENU_ITEM_ICON_DIVIDER}resetTransformFloat${MENU_ITEM_ICON_DIVIDER}${ float.id }.${ props.section?.id || "" }`
        :
        ``
    let contentTitle = [
        `Change Float${MENU_ITEM_ICON_DIVIDER}cog${MENU_ITEM_ICON_DIVIDER}editFloat${MENU_ITEM_ICON_DIVIDER}${ float.id }.${ props.section?.id || "" }`,
        // `Transform Float${MENU_ITEM_ICON_DIVIDER}resize${MENU_ITEM_ICON_DIVIDER}resetTransformFloat${MENU_ITEM_ICON_DIVIDER}${ float.id }.${ props.section?.id || "" }`,
        transform,
        [
            'Change the depth',
            `Arrange to top${MENU_ITEM_ICON_DIVIDER}double-chevron-up`,
            `Move higher${MENU_ITEM_ICON_DIVIDER}chevron-up`,
            `Move below${MENU_ITEM_ICON_DIVIDER}chevron-down`,
            `Arrange to bottom${MENU_ITEM_ICON_DIVIDER}double-chevron-down`,
        ].join(`||`),
        `Delete Float${MENU_ITEM_ICON_DIVIDER}trash${MENU_ITEM_ICON_DIVIDER}deleteFloat${MENU_ITEM_ICON_DIVIDER}${ float.id }.${ props.section?.id || "" }`,
    ].join( `|||` )

    return <div 
        className="landing-float" 
        data-content-id={float.id} 
        data-is-canvas={ float.isCanvas ? "true" : "false"}
        context-title={ isEdit ? contentTitle : undefined }
    >
    {
        float.primitives?.map((primitive, i) => {
            return <Primitive 
                key={primitive.id} 
                float={float} 
                i={i} 
                primitive={primitive} 
                animated={float.animated || [ ANIMATED_STYLE.NONE ]} 
                animated_delay={float.animated_delay || ANIMATE_DELAY.NONE} 
            />
        })
    }
    </div> 
}
export default FloatContent

